export default __webpack_public_path__ + "static/media/hubspot-logo.1c31b62f.svg";